{
  "actionbar.actions": "Akcie",
  "actionbar.actionsAvailable": "Dostupné akcie.",
  "actionbar.clearSelection": "Vymazať výber",
  "actionbar.selected": "Vybrané položky: {count}",
  "actionbar.selectedAll": "Všetky vybraté položky",
  "breadcrumbs.more": "Ďalšie položky",
  "button.pending": "čakajúce",
  "calendar.invalidSelection": "{selectedCount, plural, one {Vybratý dátum} other {Vybraté dátumy}}: nedostupné.",
  "combobox.noResults": "Žiadne výsledky",
  "contextualhelp.help": "Pomoc",
  "contextualhelp.info": "Informácie",
  "datepicker.endTime": "Čas ukončenia",
  "datepicker.startTime": "Čas začiatku",
  "datepicker.time": "Čas",
  "dialog.alert": "Upozornenie",
  "dialog.dismiss": "Zrušiť",
  "dropzone.replaceMessage": "Presuňte súbor, ktorý chcete nahradiť",
  "inlinealert.informative": "Informácie",
  "inlinealert.negative": "Chyba",
  "inlinealert.notice": "Upozornenie",
  "inlinealert.positive": "Úspech",
  "label.(optional)": "(nepovinné)",
  "label.(required)": "(povinné)",
  "menu.moreActions": "Ďalšie akcie",
  "notificationbadge.indicatorOnly": "Nová aktivita",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Vybrať…",
  "picker.selectedCount": "{count, plural, =0 {Žiadne vybraté položky} one {# vybratá položka} other {Počet vybratých položiek:#}}",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Načítava sa...",
  "table.loadingMore": "Načítava sa viac...",
  "table.resizeColumn": "Zmeniť veľkosť stĺpca",
  "table.sortAscending": "Zoradiť vzostupne",
  "table.sortDescending": "Zoradiť zostupne",
  "tag.actions": "Akcie",
  "tag.hideButtonLabel": "Zobraziť menej",
  "tag.noTags": "Žiadne",
  "tag.showAllButtonLabel": "Zobraziť všetko ({tagCount, number})",
  "toast.clearAll": "Vymazať všetko",
  "toast.collapse": "Zbaliť",
  "toast.showAll": "Zobraziť všetko"
}
